if (!customElements.get('media-slider')) {
  customElements.define(
    'media-slider',
    class MediaSlider extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.splide');
        if (!track) return;

        const init = () => {
          if (typeof Splide === 'undefined') return;

          const defaults = {
            perPage: parseInt(this.dataset.perPage) || 3,
            perMove: 1,
            gap: 16,
            arrows: true,
            pagination: true,
            speed: 400,
            breakpoints: {
              767: {
                perPage: 1,
                gap: 8,
              },
            },
          };

          let custom = {};
          const raw = this.getAttribute('m-json');
          if (raw) {
            try { custom = JSON.parse(raw); } catch (e) { console.warn('[media-slider] m-json parse error', e); }
          }

          this.splideInstance = new Splide(track, Object.assign({}, defaults, custom)).mount();

          const prevBtn = this.querySelector('.ikier-media-slider__btn--prev, [data-slider-prev]');
          const nextBtn = this.querySelector('.ikier-media-slider__btn--next, [data-slider-next]');

          if (prevBtn) prevBtn.addEventListener('click', () => this.splideInstance.go('<'));
          if (nextBtn) nextBtn.addEventListener('click', () => this.splideInstance.go('>'));

          if (prevBtn || nextBtn) {
            const syncEnds = () => {
              const end = this.splideInstance.Components.Controller.getEnd();
              if (prevBtn) prevBtn.disabled = this.splideInstance.index <= 0;
              if (nextBtn) nextBtn.disabled = this.splideInstance.index >= end;
            };
            this.splideInstance.on('mounted move updated', syncEnds);
            syncEnds();
          }
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      }
    }
  );
}
